import {Component, OnDestroy, OnInit} from '@angular/core';
import {NavigationEnd, PRIMARY_OUTLET, Router, UrlSegmentGroup, UrlTree} from '@angular/router';
import {Subscription} from 'rxjs';
import {TranslateService} from '@ngx-translate/core';
import {MenuItem} from 'primeng/api';


@Component({
  selector: 'wsd-breadcrumb',
  templateUrl: './breadcrumb.component.html',
  styleUrls: ['./breadcrumb.component.css']
})
export class BreadcrumbComponent implements OnInit, OnDestroy {

  private subscription: Subscription;

  private langChange: Subscription;

  private urlSegmentGroup: UrlSegmentGroup;

  menuItems: MenuItem[] = [];

  private breadCrumbMap: Map<string, MenuItem> = new Map();

  constructor(private router: Router,
              private translate: TranslateService) {
  }

  ngOnInit() {
    this.langChange = this.translate.onDefaultLangChange.subscribe(
      (lang: any) => {
        this.initBreadcrumbMap();
        this.setBreadCrumbModel();
      }
    );

    this.subscription = this.router.events
      .subscribe(
        (event: any) => {
          if (event instanceof NavigationEnd) {
            const tree: UrlTree = this.router.parseUrl(event.url);
            this.urlSegmentGroup = tree.root.children[PRIMARY_OUTLET];
            if (this.translate.currentLang) {
              this.setBreadCrumbModel();
            } else {
              setTimeout(() => {
                this.setBreadCrumbModel();
              }, 1000);
            }

          }
        }
      );
  }

  ngOnDestroy() {
    this.subscription.unsubscribe();
    this.langChange.unsubscribe();
  }

  private setMenuItems() {
    this.menuItems = [
      {label: this.translate.instant('MAIN_HEADER.NAVIGATION.SCOUT_ORG'), disabled: true},
      {label: this.translate.instant('MAIN_HEADER.NAVIGATION.GLOBAL_SUPPORT'), routerLink: ['contacts']}
    ];
  }

  private initBreadcrumbMap() {
    this.breadCrumbMap = new Map([
      ['/assessment/self', {label: this.translate.instant('MAIN_HEADER.NAVIGATION.ASSESSMENT.SELF'),
        routerLink: ['assessment', 'self']}],
      ['/assessment/global', {label: this.translate.instant('MAIN_HEADER.NAVIGATION.ASSESSMENT.GLOBAL'),
        routerLink: ['assessment', 'global']}],
      ['/assessment/audit', {label: this.translate.instant('MAIN_HEADER.NAVIGATION.ASSESSMENT.AUDIT'),
        routerLink: ['assessment', 'audit']}],
      ['/assessment/results', {label: this.translate.instant('MAIN_HEADER.NAVIGATION.ASSESSMENT.RESULTS'),
        routerLink: ['assessment', 'results']}],
      ['/administration', {label: this.translate.instant('MAIN_HEADER.NAVIGATION.ADMINISTRATION'),
        routerLink: ['administration']}],
      ['/administration/standard', {label: this.translate.instant('MAIN_HEADER.NAVIGATION.ADMINISTRATION_STANDARD'),
        routerLink: ['administration', 'standard']}],
      ['/consultants', {label: this.translate.instant('MAIN_HEADER.NAVIGATION.CONSULTANTS_POOL'),
        routerLink: ['consultants']}],
      ['/service-requests', {label: this.translate.instant('MAIN_HEADER.NAVIGATION.SUPPORT_PROJECTS'),
        routerLink: ['service-requests']}],
      ['/ws-directory', {label: this.translate.instant('MAIN_HEADER.NAVIGATION.WS_DIRECTORY'),
        routerLink: ['ws-directory']}],
    ]);
  }

  private setBreadCrumbModel() {
    this.setMenuItems();
    if (!this.urlSegmentGroup) {
      return;
    }

    let path = '';
    for (const segment of this.urlSegmentGroup.segments) {
      path += '/' + segment.path;
      if (this.breadCrumbMap.has(path)) {
        this.menuItems.push(this.breadCrumbMap.get(path));
      }
    }
  }

}
